import script from "./GlobusTable.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobusTable.vue?vue&type=script&setup=true&lang=js"

import "./GlobusTable.vue?vue&type=style&index=0&id=1ce0e77d&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ce0e77d"]])

export default __exports__